import axios from "axios";

export default axios.create({
    baseURL: 'https://righthome.onrender.com/'
})